module.exports = __webpack_public_path__ + "img/moshushilijin_20210901113324.2509f2f4.png";